import InPageBannerSimpleRepository from "../InPageBannerSimpleRepository"

export default class ContactInPageBannerSimple extends InPageBannerSimpleRepository {
    static schemaId = "contact_us_banner"

    constructor() {
        super(ContactInPageBannerSimple.schemaId)
    }
}
